import React from 'react';
import { IPageInfo } from '../../../components/OATableComponent';

export interface IHotelContext {
  pageInfo: IPageInfo;
  getHotelOrderList: (cb?: ((response?: any) => void) | undefined) => Promise<void>;
  getOrderById: (id: string, cb?: ((response?: any) => void) | undefined) => Promise<void>;
  getCancelReasons: (id: string, cb?: ((response?: any) => void) | undefined) => Promise<void>;
  cancelFlightsBooking: (
    id: string,
    requestBody: any,
    cb?: ((response?: any) => void) | undefined
  ) => Promise<void>;
  updateStatus: (draft: any, cb?: ((response?: any) => void) | undefined) => Promise<void>;
  downloadInvoice: (orderId: any, cb?: ((response?: any) => void) | undefined) => Promise<void>;
  downloadVoucher: (orderId: any, cb?: ((response?: any) => void) | undefined) => Promise<void>;
  downloadReport: () => void;
  report: { isLoading: boolean };
  statusChange: boolean;
}

const HotelContext = React.createContext<IHotelContext>({} as IHotelContext);

export default HotelContext;
